module.exports = __webpack_public_path__ + "static/media/banner.3fde9b9b.png";